import { gql } from 'graphql-tag'

export const REGISTER_PUSH_TOKEN = gql`
  mutation registerPushToken($platform: String, $token: String!) {
    registerPushToken(platform: $platform, token: $token)
  }
`
